module.exports = __webpack_public_path__ + "static/media/PM78.6848c869.png";